import GameManager from '../../cvp-webgames-core/GameManager';
import { constants } from '../../misc/constants';
import BaseScenarioPart from '../../cvp-webgames-core/Scenario/BaseScenarioPart';
import { VideoEnvironmentProps } from '../../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import { DaarcBaseScenario } from '../DaarcBaseScenario';
import GeneralIntroMain from '../general/intro/GeneralIntroMain';
import GeneralNeutralStateMain from '../general/neutral-state/GeneralNeutralStateMain';
import GeneralProceduresCricMain from '../general/procedures/cric/GeneralProceduresCricMain';
import GeneralProceduresNeutralStateMain from '../general/procedures/proceduresNeturalState/GeneralProceduresNeutralStateMain';
import GeneralProceduresBvmMain from '../general/procedures/bvm/GeneralProceduresBvmMain';
import GeneralProceduresEttMain from '../general/procedures/ett/GeneralProceduresEttMain';
import GeneralProceduresSgaMain from '../general/procedures/sga/GeneralProceduresSgaMain';
import { SuccessType } from '../general/general-scenario-stuff';
import GeneralProceduresAuscultateMain from '../general/procedures/auscultate/GeneralProceduresAuscultateMain';
import { VortexUICurrentAttempt } from '../../components/ui/hud/VortexUI';
import { getSaveData, registerBvmAttempt, registerEttAttempt, registerSgaAttempt, saveGame } from '../../misc/tools';

export default class BasePracticeScenario extends DaarcBaseScenario {
	public attemptTitle: string = '';
	public attemptText = '';
	private procedure = '';
	private successImgUrl = '';
	private showDebriefAfterAuscultate: boolean = false;

	public onBVMOptimizationChooseAnotherTechniqueVideoChapter(): string {
		return this._id_UpdatedNeutralLoop();
    }

	public onETTOptimizationChooseAnotherTechniqueVideoChapter(): string {
		return this._id_UpdatedNeutralLoop();
    }

	public onSGAOptimizationChooseAnotherTechniqueVideoChapter(): string {
		return this._id_UpdatedNeutralLoop();
    }

	public performActionWithWarning(actionTitle: string, warningText: string, onDone?: () => void) {
		const context = this;
		context.uiWrapper.displayGeneralAlertUI({
			title: 'Warning',
			text: warningText,
			okButton: {
				title: 'Ok',
				onClicked: () => {
					var onDoneWithPopup = context.doSomething(actionTitle);

					setTimeout(() => {
						onDoneWithPopup();
						if(onDone) {
							onDone();
						}
					}, constants.doSomethingTimeout);
				}
			}
		})
	}
	public intro = new GeneralIntroMain({
		scenario: this,
		onDone: () => {
			this.goToNeutralState();
		}
	})
	public neutralState = new GeneralNeutralStateMain({
		scenario: this,
		getSbarConfig: () => {
			return this.intro.config.part1Config.sbarConfig;
		},
		onDone: () => {
			this.goToProceduresNeutralState();
		}
	})
	public procedures = {
		neutralState: new GeneralProceduresNeutralStateMain({
			scenario: this,
			goToBvm: () => {
				this.goToBvm();
			},
			goToEtt: () => {
				this.goToEtt();
			},
			goToSga: () => {
				this.goToSga();
			},
			goToCric: () => {
				this.goToCric();
			},
			areToolsAvailable: () => {
				return this.hasInductionTimerRanOut;
			}
		}),
		auscultate:  new GeneralProceduresAuscultateMain({
			scenario: this,
			squeezeAmbuBag: true,
			onDone: (isYesClicked: boolean) => {
				const context = this;
				this.onShowSuccessFailedAttempt(this.attemptTitle, this.attemptText, this.showDebriefAfterAuscultate, () => {
					if(!context.showDebriefAfterAuscultate) {
						switch(context.procedure) {
							case 'bvm':
								context.uiWrapper.displayBVMOptimizationsUI({
									onMakeAttemptClicked: (isOneHanded: boolean, isOPA: boolean, isNPA: boolean, isManipulateHeadAndNeck: boolean) => {
										if(context.procedures.bvm.config.onMakeAttemptClicked) {
											context.procedures.bvm.config.onMakeAttemptClicked(isOneHanded, isOPA, isNPA, isManipulateHeadAndNeck);
										}
										context.toolbagId = context.uiWrapper.displayToolbag({
											isDisabled: true
										}, context.toolbagId);
										registerBvmAttempt(context);
										if(context.procedures.bvm.config.part1Config.onMakeAttemptClicked) {
											context.procedures.bvm.config.part1Config.onMakeAttemptClicked(isNPA, isOPA);
										}
										if(context.procedures.bvm.config.part1Config.onChooseHandNextClicked) {
											context.procedures.bvm.config.part1Config.onChooseHandNextClicked(isOneHanded);
										}
										context.procedures.bvm.goToStep2();
									},
									onChooseAnotherTechniqueClicked: () => {
										if(context.procedures.bvm.config.onChooseAnotherTechniqueClicked) {
											context.procedures.bvm.config.onChooseAnotherTechniqueClicked();
										}
										context.toolbagId = context.uiWrapper.displayToolbag({
											isDisabled: false
										}, context.toolbagId);

										context.neutralState.loopVideo(context.neutralState.parts[0], context.onBVMOptimizationChooseAnotherTechniqueVideoChapter())
										context.goToProceduresNeutralState();

									}
								});
								break;
							case 'ett':
								context.displayEttOptimizations();
								break;
							case 'sga':
								context.uiWrapper.displaySGAOptimizationsUI({
									onChangeSGASizeClicked: () => {
										if(context.procedures.sga.config.onChangeSGASizeClicked) {
											context.procedures.sga.config.onChangeSGASizeClicked();
										}
										context.toolbagId = context.uiWrapper.displayToolbag({
											isDisabled: true
										}, context.toolbagId);
										context.procedures.sga.goToStep1();
									},
									onChooseAnotherTechniqueClicked: () => {
										if(context.procedures.sga.config.onChooseAnotherTechniqueClicked) {
											context.procedures.sga.config.onChooseAnotherTechniqueClicked();
										}
										context.toolbagId = context.uiWrapper.displayToolbag({
											isDisabled: false
										}, context.toolbagId);
										context.neutralState.loopVideo(context.neutralState.parts[0], context.onSGAOptimizationChooseAnotherTechniqueVideoChapter())
										context.goToProceduresNeutralState();
									},
									onUpDownManeuverClicked: () => {
										if(context.procedures.sga.config.onUpDownManeuverClickedInOptimizations) {
											context.procedures.sga.config.onUpDownManeuverClickedInOptimizations();
										}
										context.toolbagId = context.uiWrapper.displayToolbag({
											isDisabled: true
										}, context.toolbagId);
										context.procedures.sga.goToStep1();
									}
								});
								break;
						}
					} else {
						if(!this.failedScenario) {
							context.unlockNextScenario();
						}
					}
				}, this.successImgUrl);

				if(context.showDebriefAfterAuscultate) {
					context.stopApneaTimerForEntireRunThrough();
				}
			}
		}),
		bvm:  new GeneralProceduresBvmMain({
			scenario: this,
			isAttemptSuccessful: () => {
				return false;
			},
			isTempSuccess: () => {
				return false;
			},
			onDone: () => {
				this.procedure = 'bvm';
				this.onBVMFinished()
			},
			onAbort: () => {
				this.goToProceduresNeutralState();
			}
		}),
		ett:  new GeneralProceduresEttMain({
			scenario: this,
			isAttemptSuccessful: () => {
				return false;
			},
			isTempSuccess: () => {
				return false;
			},
			onDone: () => {
				this.procedure = 'ett';
				this.onETTFinished()
			},
			onDoneGoToEttOptimizations: () => {
				this.displayEttOptimizations();
			},
			onAbort: () => {
				this.goToProceduresNeutralState();
			}
		}),
		sga:  new GeneralProceduresSgaMain({
			scenario: this,
			isAttemptSuccessful: () => {
				return false;
			},
			isTempSuccess: () => {
				return false;
			},
			onDone: () => {
				this.procedure = 'sga';
				this.onSGAFinished()
			},
			onAbort: () => {
				this.goToProceduresNeutralState();
			}
		}),
		cric:  new GeneralProceduresCricMain({
			scenario: this,
			isAttemptSuccessful: () => {
				return false;
			},
			onDone: () => {
				this.procedure = 'cric';
				this.onCricFinished()
			},
			onAbort: () => {
				this.goToProceduresNeutralState();
			}
		})
	}

	private displayEttOptimizations = () => {
		const context = this;
		context.uiWrapper.displayETTOptimizationsUI({
			onChangeETTechnique: () => {
				if(context.procedures.ett.config.onChangeETTechnique) {
					context.procedures.ett.config.onChangeETTechnique();
				}
				context.toolbagId = context.uiWrapper.displayToolbag({
					isDisabled: true
				}, context.toolbagId);
				context.procedures.ett.goToStep1();
			},
			onChooseAnotherTechniqueClicked: () => {
				if(context.procedures.ett.config.onChooseAnotherTechniqueClicked) {
					context.procedures.ett.config.onChooseAnotherTechniqueClicked();
				}
				context.toolbagId = context.uiWrapper.displayToolbag({
					isDisabled: false
				}, context.toolbagId);
				context.neutralState.loopVideo(context.neutralState.parts[0], context.onETTOptimizationChooseAnotherTechniqueVideoChapter())
				context.goToProceduresNeutralState();
			}
		});
	}
	
	public parts: BaseScenarioPart<DaarcBaseScenario>[] = [].concat(this.intro.parts)
														.concat(this.neutralState.parts)
														.concat(this.procedures.auscultate.parts)
														.concat(this.procedures.bvm.parts)
														.concat(this.procedures.ett.parts)
														.concat(this.procedures.sga.parts)
														.concat(this.procedures.cric.parts)

	public onBVMFinished() : void  {
		throw new Error('onBVMFinished must be implemented');
	}

	public onETTFinished() : void  {
		throw new Error('onETTFinished must be implemented');
	}

	public onSGAFinished() : void  {
		throw new Error('onSGAFinished must be implemented');
	}

	public onCricFinished() : void  {
		throw new Error('onCricFinished must be implemented');
	}
	public stopApneaTimerForEntireRunThrough() {
		var stopTimer = (window as any)['stopApneaTimer'];
		var stopBar = (window as any)['stopApneaBar'];

		if(stopTimer) {
			stopTimer();
		}

		if(stopBar) {
			stopBar();
		}

		this.resetApneaTimerForEntire(true);
	}

	public getDefaultApneaTime() : number {
		throw new Error('getDefaultApneaTime must be implemented');
	}

	public getDefaultSa02(): number {
		throw new Error('getDefaultSa02 must be implemented');
	}

	public resetApneaTimerForEntire(stopSa02?: boolean) {
		const context = this;
		var apneaTime = (window as any)['reset-apnea-time'] ?? context.getDefaultApneaTime();
		var sa02 = (window as any)['preoxy'] ?? context.getDefaultSa02();
		context.sideMenuId = context.uiWrapper.displaySideMenu({
			updatedStuff: {
				apneaTimeInSeconds: apneaTime,
				sa02: sa02,
				stopSa02: stopSa02,
				resetEtc02: true
			}
		}, context.sideMenuId);
	}

	public showFailedScenarioPopUp(text: string, title?: string, imgUrl?: string) {
		this.attemptTitle = title ?? constants.attemptText.failedTitle;
		this.attemptText = text;
		this.successImgUrl = imgUrl;
		this.failedScenario = true;
		this.onShowSuccessFailedAttempt(this.attemptTitle, this.attemptText, true);
		this.stopApneaTimerForEntireRunThrough();
	}
	
	public showFailedScenarioPopUpAfterAuscultate(procedure: VortexUICurrentAttempt, text?: string, title? :string, imgUrl?: string) {
		this.attemptTitle = title ?? constants.attemptText.failedTitle;
		this.attemptText = text ?? constants.attemptText.bvm.failedMessage;
		this.successImgUrl = imgUrl;
		this.showDebriefAfterAuscultate = true;
		this.failedScenario = true;
		this.goToAuscultate(procedure);
	}

	public showFailedAttemptPopUpAfterAuscultate(procedure: VortexUICurrentAttempt, text?: string, title? :string, imgUrl?: string) {
		this.attemptTitle = title ?? constants.attemptText.failedTitle;
		this.attemptText = text ?? constants.attemptText.ett.failedMessage;
		this.successImgUrl = imgUrl;
		this.showDebriefAfterAuscultate = false;
		this.goToAuscultate(procedure);
	}

	public showSuccessPopUpAfterAuscultate(procedure: VortexUICurrentAttempt, text?: string, title? :string, imgUrl?: string) {
		this.attemptTitle = title ?? constants.attemptText.successTitle;
		this.attemptText = text ?? constants.attemptText.cric.successMessage;
		this.successImgUrl = imgUrl;
		this.showDebriefAfterAuscultate = true;
		this.goToAuscultate(procedure);
	}

	public showTempSuccessPopUpAfterAuscultate(msg: string, procedure: VortexUICurrentAttempt, title?: string, imgUrl?: string) {
		this.attemptTitle = title ?? constants.attemptText.tempsuccessTitle;
		this.attemptText = msg;
		this.successImgUrl = imgUrl;
		this.showDebriefAfterAuscultate = false;
		this.goToAuscultate(procedure);
	}

	public get maxScore(): number {
		return 5000;
	}

	public get predeterminedPoints(): number {
		var assessPatientRemoveDenturesPoints = 500;
		var setupFiberOpticsPoints = 1000;

		return assessPatientRemoveDenturesPoints + 
					setupFiberOpticsPoints;
    }

	public get totalNumberOfQuestions(): number {
		return 5;
	}

	public getEnvironmentProps(): VideoEnvironmentProps {
		return {
			controls: false
		};
	}
	
	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}


	public getParts(): BaseScenarioPart<DaarcBaseScenario>[] {
		return this.parts;
	}

	start() {
		(window as any)['isCric'] = this.neutralState.config.part1Config.isCric;
		this.goToIntro();
		// this.uiWrapper.displayAdministerMedsUI({
		// 	personIconImage: 'personIcon',
		// 	drugText: 'Neuromuscular Junction Blocker',
		// 	onCloseClicked: () => {
		// 	},
		// 	onAdministerClicked: () => {
		// 	}
		// })
		// this.doSomething('Administering Neuromuscular Junction Blocker...')
		// this.uiWrapper.displayEttOptionsUI({
		// 	OnNextClicked: () => {}
		// })
		// this.uiWrapper.displayInsertionAngleUI({
		// 	OnNextClicked: () => {}
		// })
		// const context = this;
		// context.sideMenuId = context.uiWrapper.displaySideMenu({
		// 	gameManager: this.gameManager,
		// 	inductionTimeInSeconds: 5,
		// 	apneaTimeInSeconds: 210,
		// 	bloodPressureNumerator: 150,
		// 	bloodPressureDenominator: 90,
		// 	bloodPressureMinNumerator: 50,
		// 	bloodPressureMinDenominator: 33,
		// 	bloodPressureMaxNumerator: 220,
		// 	bloodPressureMaxDenominator: 110,
		// 	sa02: 91,
		// 	heartRate: 110,
		// 	heartRateMax: 150,
		// 	respirationRate: 28,
		// 	resetEtc02: false,
		// 	etc02: 35,
		// 	showETC02: false,
		// 	isApneaTimerIdle: false,
		// 	onInductionTimerRanOut: () => {
		// 		context.hasInductionTimerRanOut = true;
		// 	},
		// 	onApneaTimerRanOut: () => {
        //         context.failedScenario = true;
		// 		context.onShowSuccessFailedAttempt(constants.attemptText.failedTitle, 'You did not establish a stable, patent airway in time to save Faith Alvarado’s life. She has expired. Review the debrief and then try the scenario again.', true);
		// 	}
		// }, context.sideMenuId);
		// this.goToProceduresNeutralState();

		// this.isDebug = true;
		// this.failedScenario = true;

		// var savedData = getSaveData();

		// for(var indx = 0; indx < savedData.scenarios.length; indx++) {
		// 	if(savedData.scenarios[indx].scenarioWindow.toString() === this.scenarioName) {

		// 		savedData.scenarios[indx].score = 100;
		// 		savedData.scenarios[indx].isCompleted = true;
		// 	}
		// }

        // saveGame(savedData);

		// this.unlockNextScenario();
		// this.displayDebrief();
		// this.onShowSuccessFailedAttempt(this.attemptTitle, this.attemptText, true, () => {});
	}

	goToIntro() {
		this.intro.start();
	}

	goToNeutralState() {
		this.neutralState.start();
	}

	goToProceduresNeutralState() {
		this.procedures.neutralState.start();
	}

	goToBvm() {
		this.procedures.bvm.start();
	}

	goToEtt() {
		this.procedures.ett.start();
	}

	goToSga() {
		this.procedures.sga.start();
	}

	goToCric() {
		this.procedures.cric.start();
	}

	goToAuscultate(procedure: VortexUICurrentAttempt) {
		this.procedures.auscultate.start(procedure);
	}
}